import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card, Avatar, CardHeader, CardContent, Box, Link, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { HealthSystemDomainUsersResultUserViewModel } from '../api/HealthSystemApi';

interface FarmUserCardProps {
  user: HealthSystemDomainUsersResultUserViewModel;
  action: React.ReactElement;
}

const useStyles = makeStyles(() =>
  createStyles({
    headerText: {
      display: 'flex',
      alignItems: 'center'
    },
    cardContent: {
      paddingTop: 0
    }
  })
);

const FarmUserCard = ({ user, action }: FarmUserCardProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box width={1}>
      <Card elevation={1}>
        <CardHeader
          avatar={<Avatar color="primary">{user.name?.[0] || 'U'}</Avatar>}
          action={action}
          title={user.name}
          subheader={user.role}
        />
        <CardContent className={classes.cardContent}>
          <Typography variant="subtitle2">{t('f-com-email')}</Typography>
          <Link href={`mailto:${user.email}`} variant="body1">
            {user.email}
          </Link>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FarmUserCard;
